import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getPolyglot } from '../../../../i18n';
import { NormalizedGroup } from '../../../../redux/groups/api/GroupAdapter';
import { ArrowCircleLeftIcon, MercIcon } from '../../theme/icons';

export const StoreSubheader = ({
  group,
}: {
  group: NormalizedGroup | undefined;
}) => {
  const navigate = useNavigate();
  const polyglot = getPolyglot();
  return (
    <Box
      alignItems="center"
      gap={2}
      sx={{
        paddingBottom: '1rem',
        backgroundColor: 'background.default',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'background.container',
        }}
      >
        <Box sx={{ borderBottom: '1px solid', borderColor: 'secondary.main' }}>
          <Box
            padding="1rem"
            ml="3.5rem"
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Button
              variant="text"
              onClick={() => {}}
              color="primary"
              disableRipple={true}
              disableFocusRipple={true}
              disableTouchRipple={true}
              sx={{
                padding: 0,
                width: 'auto',
                minWidth: 'auto',
                cursor: 'default',
                '&:hover': { backgroundColor: 'transparent' },
              }}
            >
              <MercIcon height={'2.5rem'} color="primary" />
            </Button>
            <Box>
              <Typography variant="h3">{group?.name}</Typography>
              <Typography variant="caption" color="text.primary">
                {group?.childGroups.length}{' '}
                {group?.childGroups?.length === 1
                  ? polyglot.t('freshwatch.dashboard.merchandiser')
                  : polyglot.t('freshwatch.dashboard.merchandisers')}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            marginLeft: '3.5rem',
            padding: '1rem',
          }}
        >
          <Button
            onClick={() => {
              navigate(-1);
            }}
            sx={{
              minWidth: 'auto',
            }}
            variant="text"
            startIcon={
              <ArrowCircleLeftIcon height={'1.5rem'} color="primary.main" />
            }
          >
            <Typography variant="subtitle2" color="text.primary">
              {polyglot.t('button.back')}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
